import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function AfterOrder() {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        disableBackdropClick={false}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Order Placed"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your order has been placed ! We will deliver in 24 Hour Max.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { window.location.reload(); }} color="primary">
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}